import {React, useEffect, useState, useRef} from 'react'
import { connect } from 'react-redux'
import dayjs from 'dayjs'
import 'dayjs/locale/ru';
import '../App.css'
import { Drawer, Form, Button, Col, Row, Input, Select, DatePicker, Space } from 'antd';
import { useIntl } from 'react-intl';
import {getSafeArray, getDateRange} from '../utils/utils'
import { setReportFilter } from '../actions/reportfilterAction.js'
import NagScreen from './NagScreen';

const { Option } = Select;

const DrawerForm = (props) => {

    const changedData = useRef({});
    const intl = useIntl();

    const [state, setState] = useState({
        visible: false,
        periodEnabled: false,
        submitEnabled: false
        });

    useEffect(() => {
        dayjs().locale(navigator.language || navigator.userLanguage).format();    
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const [form] = Form.useForm();    
    
    const onClear = (e = null, update = true) => {
      changedData.current = {};
      changedData.current.toDate = dayjs();
      changedData.current.fromDate = dayjs(new Date(dayjs().year(), 0, 1, 0, 0));
      changedData.current.period = 'thisYear';

      form.setFieldsValue({
          period: [changedData.current.fromDate, changedData.current.toDate],
          period_type: changedData.current.period,
          document: null,
          min_pages: null,
          max_pages: null,
          min_cost: null,
          max_cost: null,
          color: null,
          duplex: null,
      });

      if (update)
      {
          setState({...state, submitEnabled: true, periodEnabled: false});
      }
  }
    
    function onPeriodType(newType) {

        const range = getDateRange(newType);
        changedData.current.fromDate = range.fromDate;
        changedData.current.toDate = range.toDate;

        form.setFieldsValue({
            period: [changedData.current.fromDate, changedData.current.toDate],
        });

        setState({...state, periodEnabled: newType === 'custom', submitEnabled: true});

        changedData.current.period = newType;
    }

    function onDateRangeChange(date, dateString) {
        if (getSafeArray(date).length > 0)
        {
            changedData.current.fromDate = date[0];
            changedData.current.toDate = date[1];
        }
        else
        {
            changedData.current.fromDate = null;
            changedData.current.toDate = null;
        }

        setState({...state, submitEnabled: true});
    }  

    const showDrawer = () => {
        setState({...state, visible: true });
    };

    const onClose = () => {
        onClear(null, false);
        setState({...state, visible: false, submitEnabled: false });
    };

    const onSubmit = () => {
        props.setData(changedData.current);

        setState({...state, visible: false, submitEnabled: false });
    };
    
    var fromDate = dayjs(new Date(props.filterData.fromDate.year(), props.filterData.fromDate.month(), props.filterData.fromDate.date(), 0, 0));
    var toDate = dayjs(new Date(props.filterData.toDate.year(), props.filterData.toDate.month(), props.filterData.toDate.date(), 23, 59, 59));

    const title = fromDate.format('LL') + ' - ' + toDate.format('LL');

    const onInputChange = (changedField) => {

        if (changedField.target.id === 'document')
        {
            changedData.current.document = changedField.target.value;    
        }
        else if (changedField.target.id === 'min_pages')
        {
            const minPages = parseInt(changedField.target.value);
            changedData.current.minPages = isNaN(minPages) || minPages < 0 ? null: minPages;    
        }
        else if (changedField.target.id === 'max_pages')
        {
            const maxPages = parseInt(changedField.target.value);
            changedData.current.maxPages = isNaN(maxPages) || maxPages < 0 ? null: maxPages;    
        }
        else if (changedField.target.id === 'min_cost')
        {
            const minCost = parseFloat(changedField.target.value);
            changedData.current.minCost = isNaN(minCost) || minCost < 0 ? null : minCost;
        }
        else if (changedField.target.id === 'max_cost')
        {
            const maxCost = parseFloat(changedField.target.value);
            changedData.current.maxCost = isNaN(maxCost) || maxCost < 0 ? null : maxCost;
        }

        setState({...state, submitEnabled: true});
    }

    const onColorChange = (value) => {
        changedData.current.color = value;
        setState({...state, submitEnabled: true});
    }

    const onDuplexChange = (value) => {
        changedData.current.duplex = value;
        setState({...state, submitEnabled: true});
    }

    return (
      <>
        <NagScreen/>
        <Button type="ghost" onClick={showDrawer}>
        {title}
        </Button>
        <Drawer
        forceRender
          width={520}
          onClose={onClose}
          open={state.visible}
          placement	="right"
          extra={
            <Space>
              <Button onClick={(e) => onClear(e)}>{intl.formatMessage({ id: "Clear" })}</Button>
              <Button onClick = {onSubmit} type="primary" disabled = {!state.submitEnabled}>{intl.formatMessage({ id: "Submit" })}</Button>
            </Space>
          }
        >
          <Form form={form} 
            layout="vertical"
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="period"
                >
                    <DatePicker.RangePicker onChange={(date, dateString) => onDateRangeChange(date, dateString)} 
                        defaultValue={[props.filterData.fromDate, props.filterData.toDate]} disabled = {!state.periodEnabled}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="period_type"
                >
                <Select defaultValue={props.filterData.period} onChange={(newType) => onPeriodType(newType)}>
                    <Option value="custom">{intl.formatMessage({ id: "Custom" })}</Option>
                    <Option value="today">{intl.formatMessage({ id: "Today" })}</Option>
                    <Option value="yesterday">{intl.formatMessage({ id: "Yesterday" })}</Option>
                    <Option value="lastWeek">{intl.formatMessage({ id: "LastWeek" })}</Option>
                    <Option value="lastMonth">{intl.formatMessage({ id: "LastMonth" })}</Option>
                    <Option value="last7days">{intl.formatMessage({ id: "Last7days" })}</Option>
                    <Option value="last30days">{intl.formatMessage({ id: "Last30days" })}</Option>
                    <Option value="thisYear">{intl.formatMessage({ id: "ThisYear" })}</Option>
                </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
            <Col span={24}>
                <Form.Item
                  name="document"
                  label={intl.formatMessage({ id: "DocumentNameContains" })}
                >
                    <Input defaultValue={props.filterData.document} onChange = {(e) => onInputChange(e)}/>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
            <Col span={12}>
                <Form.Item
                  name="min_pages"
                  label={intl.formatMessage({ id: "MinPages" })}
                >
                    <Input defaultValue={props.filterData.minPages} onChange = {(e) => onInputChange(e)}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="max_pages"
                  label={intl.formatMessage({ id: "MaxPages" })}
                >
                    <Input defaultValue={props.filterData.maxPages} onChange = {(e) => onInputChange(e)}/>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
            <Col span={12}>
                <Form.Item
                  name="min_cost"
                  label={intl.formatMessage({ id: "MinCost" })}
                >
                    <Input defaultValue={props.filterData.minCost} onChange = {(e) => onInputChange(e)}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="max_cost"
                  label={intl.formatMessage({ id: "MaxCost" })}
                >
                    <Input defaultValue={props.filterData.maxCost} onChange = {(e) => onInputChange(e)}/>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
            <Col span={12}>
                <Form.Item
                  name="color"
                  label={intl.formatMessage({ id: "DeviceMetersTable.color_pages" })}
                >
                <Select defaultValue={props.filterData.color} onChange = {(value, option) => onColorChange(value)}>
                    <Option value={null}>{intl.formatMessage({ id: "NotSet" })}</Option>
                    <Option value={1}>{intl.formatMessage({ id: "Yes" })}</Option>
                    <Option value={0}>{intl.formatMessage({ id: "No" })}</Option>
                </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="duplex"
                  label={intl.formatMessage({ id: "Duplex" })}
                >
                <Select defaultValue={props.filterData.duplex} onChange = {(value) => onDuplexChange(value)}>
                    <Option value={null}>{intl.formatMessage({ id: "NotSet" })}</Option>
                    <Option value={1}>{intl.formatMessage({ id: "Yes" })}</Option>
                    <Option value={0}>{intl.formatMessage({ id: "No" })}</Option>
                </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
}

const mapStateToProps = (state) => {
    return {
        filterData: state.reportFilter
    };
  };     
  
  const mapDispatchToProps = (dispatch) => {
  return {
      setData: (filter) => dispatch(setReportFilter(filter)),
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(DrawerForm)
